import React from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TransactionResult } from '../../shared/enums/TransactionResult';
import Box from '@material-ui/core/Box';
import Success from './Success/index';
import Failure from './Failure/index';

const useStyles = makeStyles({
	mainBox: {
		backgroundColor: '#FFFFFF',
		width: '50%',
	},
});

const Transaction = (props: any) => {
	const classes = useStyles(props);
	const { result } = useParams<{ result: string }>();

	return (
		<>
			<Box
				display='flex'
				justifyContent='center'
				alignItems='center'
				minHeight='60vh'
			>
				<Box p={6} boxShadow={1} className={classes.mainBox}>
					{result === TransactionResult.SUCCESS && <Success />}
					{result === TransactionResult.FAILED && <Failure />}
				</Box>
			</Box>
		</>
	);
};

export default Transaction;
